import { combineReducers } from "redux";

import { productList } from "./productList";
import { productDetail } from "./productDetail";
import { navigation } from "./navigation";
import { navHeader } from "./navHeader";
import { basket } from "./basket";
import { checkout } from "./checkout";
import { signup } from "./signup";
import { auth } from "./auth";
import { customerList } from "./customerList";
import { customerDetail } from "./customerDetail";
import { widgets } from "./widgets";
import { homeWidget } from "./homeWidget";
import { stores } from "./stores";
import { staffs } from "./staffs";
import { orderSearch } from "./orderSearch";
import { orderRefund } from "./orderRefund";
import { orderCancellation } from "./orderCancellation";
import { orderAccept } from "./orderAccept";
import { orderDelivery } from "./orderDelivery";
import { packageOrderList } from "./packageOrderList";
import { paymentOrderList } from "./paymentOrderList";
import { stockLocation } from "./stockLocation";
import { packageStatuses } from "./packageStatuses";
import { paymentStatuses } from "./paymentStatuses";
import { packageStockLocations } from "./packageStockLocations";
import { paymentStockLocations } from "./paymentStockLocations";
import { packageDenialReasons } from "./packageDenialReasons";
import { packageOrderDetail } from "./packageOrderDetail";
import { omnitronOrders } from "./omnitronOrders";
import { packages } from "./packages";
import { packageDeliveryRanges } from "./packageDeliveryRanges";
import { paymentDeliveryRanges } from "./paymentDeliveryRanges";
import { packaging } from "./packaging";
import { detectingOutOfStock } from "./detectingOutOfStock";
import { omsCommand as packageOmsCommand } from "./packageOmsCommand";
import { omsCommand as transferOmsCommand } from "./transferOmsCommand";
import { transferOrderList } from "./transferOrderList";
import { transferStatuses } from "./transferStatuses";
import { transferStockLocations } from "./transferStockLocations";
import { transfers } from "./transfers";
import { transferOrderDetail } from "./transferOrderDetail";
import { imageModal } from "./imageModal";
import { signinWithSms } from "./signinWithSms";
import { signin } from "./signin";
import { cargoCompanies } from "./cargoCompanies";
import { permissions } from "./permissions";
import { brandDetail } from "./brandDetail";
import { itemQuestions } from "./itemQuestions";
import { calculateQuestions } from "./calculateQuestions";
import { orderCalculateQuestions } from "./orderCalculateQuestions";
import { changeItemOrderDetail } from "./changeItemOrderDetail";
import { paymentOrderDetail } from "./paymentOrderDetail";
import { onCallOrderDetail } from "./oncallOrderDetail";
import { productBundleCampaign } from "./productBundleCampaign";
import { bundleBasketOffers } from "./bundleBasketOffers";
import { webUrl } from "./liveCommerceReducers/webUrl";
import { clickAndCollectOrderList } from "./clickAndCollectOrderList";
import { clickAndCollectOrderDetail } from "./clickAndCollectOrderDetail";
import { miscProduct } from "./miscProduct";

const rootReducer = combineReducers({
  auth,
  basket,
  brandDetail,
  bundleBasketOffers,
  calculateQuestions,
  cargoCompanies,
  changeItemOrderDetail,
  checkout,
  clickAndCollectOrderDetail,
  clickAndCollectOrderList,
  customerDetail,
  customerList,
  detectingOutOfStock,
  homeWidget,
  imageModal,
  itemQuestions,
  navHeader,
  navigation,
  onCallOrderDetail,
  omnitronOrders,
  orderAccept,
  orderCalculateQuestions,
  orderDelivery,
  orderRefund,
  orderCancellation,
  orderSearch,
  packageDeliveryRanges,
  packageOmsCommand,
  packageOrderDetail,
  packageOrderList,
  packages,
  packageDenialReasons,
  packageStatuses,
  packageStockLocations,
  packaging,
  paymentDeliveryRanges,
  paymentOrderDetail,
  paymentOrderList,
  paymentStatuses,
  paymentStockLocations,
  permissions,
  productBundleCampaign,
  productDetail,
  productList,
  signin,
  signinWithSms,
  signup,
  staffs,
  stockLocation,
  stores,
  transferOmsCommand,
  transferOrderDetail,
  transferOrderList,
  transfers,
  transferStatuses,
  transferStockLocations,
  webUrl,
  widgets,
  miscProduct,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js